export const GET_CATEGORIES = 'GET_CATEGORIES';

export const SHOW_IMAGE_VIEWER = 'SHOW_IMAGE_VIEWER';
export const HIDE_IMAGE_VIEWER = 'HIDE_IMAGE_VIEWER';
export const SET_IMAGE_VIEWER_DATA = 'SET_IMAGE_VIEWER_DATA';

export default {
  GET_CATEGORIES,

  SHOW_IMAGE_VIEWER,
  HIDE_IMAGE_VIEWER,
  SET_IMAGE_VIEWER_DATA,
};
